import React, { useEffect, useState } from "react";
import { toLower } from "lodash";

import { uploadErrorFileToCoreplus } from "services/uploadFileToCoreplus";

function SpecialistFileUpload({ file, specialistProfiles, fromReferralInbox, aiOcr }) {
  const [profiles, setProfiles] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedSpecialistId, setSelectedSpecialistId] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [failureReason, setFailureReason] = useState(null);

  useEffect(() => {
    if (search.length < 3) {
      setProfiles([]);
      return;
    }

    setProfiles(
      specialistProfiles.filter((p) => {
        const fullname = `${toLower(p.firstName)} ${toLower(p.lastName)}`;
        const index = fullname.indexOf(toLower(search));
        return index < 0 ? false : true;
      })
    );
  }, [specialistProfiles, search]);

  const handleKeyUp = (e) => {
    setSearch(e.target.value);
  };

  const handleSelectSpecialist = (id) => {
    setSelectedSpecialistId(id);
  };

  const uploadTheTestResult = async () => {
    setFailureReason(null);
    setIsUploading(true);

    const { error: uploadError } = await uploadErrorFileToCoreplus({
      clientId: "",
      fileId: file?.id,
      //When file is from referral in box, it is name, from medical result ,it is fileName
      fileName: file?.fileName ?? file.name, // this is for medical result
      specialistId: selectedSpecialistId,
      fromReferralInbox,
      aiOcr,
    });
    if (uploadError) {
      setFailureReason(uploadError.message);
      setIsUploading(false);
      return;
    }
    setIsUploading(false);
    window.location.reload(false);
  };

  return (
    <>
      <p className="is-size-7 pb-4">
        If you can't find THE EXISTING patient above but you know the specialist this result belongs to, please search
        and select that specialist, then upload result.
      </p>
      <div className="columns">
        <div className="column">
          <div className="field">
            <input
              type="text"
              className="input is-small is-radiusless"
              placeholder="Please type specialist name here"
              onKeyUp={handleKeyUp}
            />
          </div>
          <div className="table-container apt-table">
            <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
              <thead>
                <tr>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {profiles.map((p) => (
                  <tr
                    className={`${p.id === selectedSpecialistId ? "is-active " : ""}is-hovered`}
                    key={p.id}
                    onClick={() => handleSelectSpecialist(p.id)}
                  >
                    <td>{`${p.firstName} ${p.lastName}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            disabled={!selectedSpecialistId || isUploading}
            onClick={uploadTheTestResult}
            className={`button is-primary is-small is-radiusless${isUploading ? " is-loading" : ""}`}
          >
            Upload to practitioner medical result
          </button>
          {failureReason == null ? null : <div className="notification is-danger is-light mt-2">{failureReason}</div>}
        </div>
      </div>
    </>
  );
}

export default SpecialistFileUpload;
